import { render } from "./Emails-editor.vue?vue&type=template&id=34ec6ff4&scoped=true"
import script from "./Emails-editor.vue?vue&type=script&lang=js"
export * from "./Emails-editor.vue?vue&type=script&lang=js"

import "./emailsEditor.scss?vue&type=style&index=0&id=34ec6ff4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ec6ff4"]])

export default __exports__